import { TemporaryRegistrationSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useTemporaryRegistrationSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = TemporaryRegistrationSchema({
    RequiredMessage: t('Validate_Required'),
    PhoneNumberMessage: t('Validate_PhoneNumber'),
    FullWidthMessage: t('Validate_FullWidth'),
  });
  return schema;
};
